import { render } from "./DocTabPage.vue?vue&type=template&id=8baea79e&scoped=true"
import script from "./DocTabPage.vue?vue&type=script&lang=js"
export * from "./DocTabPage.vue?vue&type=script&lang=js"

import "./DocTabPage.vue?vue&type=style&index=0&id=8baea79e&scoped=true&lang=css"
import "./DocTabPage.vue?vue&type=style&index=1&id=8baea79e&lang=css"

import exportComponent from "/root/.jenkins/workspace/hidoc/hidoc-web/03_SRC/hidoc-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8baea79e"]])

export default __exports__